import { render, staticRenderFns } from "./lawcomponentbl.vue?vue&type=template&id=e73ec944&scoped=true&"
import script from "./lawcomponentbl.vue?vue&type=script&lang=js&"
export * from "./lawcomponentbl.vue?vue&type=script&lang=js&"
import style0 from "./lawcomponentbl.vue?vue&type=style&index=0&id=e73ec944&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73ec944",
  null
  
)

export default component.exports